// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"fN-z","inlineTitle":"gN-z","sponsoredAdsWrapper":"hN-z","marketplaceRecosWrapper":"iN-z"};